export default "__VITE_ASSET__Bjk5Yf3E__"